import { EntityType, type SearchOption } from 'components'
import { http } from 'interfaces'
import { type Country } from 'services'

export interface SearchResponse {
  organizations: Array<{
    id: string
    organization_name: string
    country: Country
    type: string
    top_level_name: string
  }>
  people: Array<{
    id: string
    first_name: string
    last_name: string
    primary_position: {
      title: string
      org: string
    }
  }>
  positions: Array<{
    id: string
    title: string
    org: string
    person: {
      first_name: string
      last_name: string
    }
  }>
}

async function searchServerCall (searchTerm: string, organizations: boolean, people: boolean, positions: boolean): Promise<SearchResponse> {
  const params: {
    people?: string
    positions?: string
    organizations?: string
  } = {}

  if (organizations) {
    params.organizations = searchTerm
  }
  if (people) {
    params.people = searchTerm
  }
  if (positions) {
    params.positions = searchTerm
  }
  return await http
    .get('/api/v1/autocomplete/', {
      params
    }).then(value => value.data)
}

export const searchWithQueryAndParams = async (searchTerm: string, organizations: boolean, people: boolean, positions: boolean): Promise<SearchOption[]> => {
  return await searchServerCall(searchTerm, organizations, people, positions)
    .then((response) => {
      let updatedOptions: SearchOption[] = []
      const updatedOrgs = response.organizations.map((o) => ({
        title: `${o.id}: ${o.organization_name} (${o?.country?.country_desc} - ${o.type} - ${o.top_level_name})`,
        id: 'org-' + o.id,
        type: EntityType.ORGANIZATION,
        refId: o.id
      }))
      updatedOptions = updatedOptions.concat(updatedOrgs)
      return updatedOptions
    })
    .catch((reason: any) => {
      console.log(reason)
      return []
    })
}
